import type { FileConfig } from '../types/FileConfig';
import { MICROPULSE_CONFIGS } from './MicroPulseConfigs';
import { CORTEX_CONFIGS } from './CortexConfigs';
import { HOPRX_CONFIGS } from './HopRxConfigs';
import { HOPTX_CONFIGS } from './HopTxConfigs';
import { HASS_CONFIGS } from './HassConfigs';

/**
 * Consolidated configuration object containing all Erdos Miller file type configurations
 * Maintains backward compatibility with the original CONFIGS export
 */
export const CONFIGS: Record<string, FileConfig> = {
  ...MICROPULSE_CONFIGS,
  ...CORTEX_CONFIGS,
  ...HOPRX_CONFIGS,
  ...HOPTX_CONFIGS,
  ...HASS_CONFIGS
};

// Re-export individual config groups for granular access
export { MICROPULSE_CONFIGS } from './MicroPulseConfigs';
export { CORTEX_CONFIGS } from './CortexConfigs';
export { HOPRX_CONFIGS } from './HopRxConfigs';
export { HOPTX_CONFIGS } from './HopTxConfigs';
export { HASS_CONFIGS } from './HassConfigs';

// Re-export the FileConfig type for convenience
export type { FileConfig } from '../types/FileConfig';
